import i18next from "i18next";
import CookiesStore from "./Common/Storage/cookiesStore";
import {ConfigApi} from "./Api/types";
import StoreUtils from "./Store/StoreUtils";

export const defaultLocale = "pl";
let selectedLocale: string | undefined = undefined;
const languages: Record<string, any> = {
    "en": {
        "locale": "en",
        "nativeName": "English",
        "englishName": "English"
    },
    "pl": {
        "locale": "pl",
        "nativeName": "Polski",
        "englishName": "Polish"
    },
};

export const getSupportedLanguages = () => {
    return languages;
}

export const getPossibleLanguages = (fetchedLanguages: string[]) => {
    return fetchedLanguages.filter(language => !!languages[language]).sort((a,b) => a.localeCompare(b));
}

export const getLanguagesBasedOnStoreType = (defaultConfig: ConfigApi | undefined) => {
    return defaultConfig?.languages || [];
}

export const getLangDisplayName = (locale?: string) => {
    if (!locale) return null;

    if(locale.includes("-")) {
        const localeParts = locale.split("-");
        return languages[localeParts[0]]?.nativeName;
    }
    return languages[locale]?.nativeName;
}

export async function changeLocale(locale: string) {
    initLocale(locale);
}

export const findLanguageBasedOnLocale = (languages: string[], locale?: string) => {
    if(!locale) return undefined;

    return languages.find(language => locale.startsWith(language));
}

export function initLocale(newLocale?: string, languages?: string[]) {
    const supportedLanguages: string[] = languages ?? Object.values(getSupportedLanguages()).map((value) => value.locale);
    let locale = selectedLocale;

    if (newLocale) {
        const language = findLanguageBasedOnLocale(supportedLanguages, newLocale);
        if (language) {
            locale = language;
        }
    }

    if (!locale) {
        const localeFromCookiesStore = CookiesStore.get("language");
        if(localeFromCookiesStore) {
            locale = localeFromCookiesStore
        }
        else {
            locale =  navigator.language;
        }
    }

    const language = findLanguageBasedOnLocale(supportedLanguages, locale);

    if(!language) {
        locale = defaultLocale;
    }

    if (selectedLocale === locale) {
        return locale ? locale : defaultLocale;
    }

    const localeParts = locale?.split("-");

    if (i18next && i18next.language && ((i18next.language && i18next.language !== locale) || !i18next.language)) {
        if(localeParts) {
            i18next.changeLanguage(localeParts[0]);
        }
    }

    CookiesStore.setGlobal("language", locale);
    selectedLocale = locale;

    return localeParts && localeParts[0] ? localeParts[0] : defaultLocale;
}


const getTranslation = (locale: any, field: any, translations: any, defaultValue: any) => {
    if (translations === undefined) {
        return defaultValue;
    }

    let translation = translations.filter((translation: any) => locale.startsWith(translation.locale))[0];
    if (translation && translation[field]) {
        return translation[field];
    }
    return defaultValue;
}

export const getElementTranslation = (locale: any, element: any, fields: any) => {
    let translation = {} as any;
    fields.forEach((field: any) => {
        translation[field] = getTranslation(locale, field, element.translations, element[field])
    })
    return translation;
}

export const getElementTranslations = (locale: any, elements: any, fields: any) => {
    return elements.map((element: any) => {
        element.translation = getElementTranslation(locale, element, fields);
        // fields.forEach(field => {
        //     element.translation[field] = getTranslation(locale, field, element.translations, element[field])
        // })
        return element;
    });
}